import styled from "@emotion/styled";
import {
  Col,
  Dropdown,
  MenuProps,
  Radio,
  Tag,
  Typography,
} from "antd";
import { FC, useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { convertTransport } from "utils/convertData";
import { TaxAddressData } from "services/interface";


interface TaxAddressCardProps {
  data: TaxAddressData | undefined;
  index: number;
  handleRemoveItem?: (target: any) => void;
  showEdit?: (id: string) => void;
  changeDefault?: (id: string) => void;
  canUpdate?: boolean;
}


const TaxAddressCard: FC<TaxAddressCardProps> = (
  { 
    data,
    index, 
    handleRemoveItem, 
    showEdit, 
    changeDefault, 
    canUpdate,
  }) => { 
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const handleDropdownVisibleChange = (visible: boolean) => {
    setIsDropdownOpen(visible);
  };

  const removeEvent = (id: string) => {
    if (handleRemoveItem) {
      handleRemoveItem(id)
    }
    setIsDropdownOpen(false);
  };
 
  const handleShowEdit = (id: string) => {
    if (showEdit) {
      showEdit(id);
    }
    setIsDropdownOpen(false);
  };

  const handleRadioChange = () => {
    if (changeDefault) {
      changeDefault(data?.id || ''); 
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "0",
      label: <div 
      onClick={() =>  
        handleShowEdit(data?.id ?? '')
      } 
      >แก้ไข</div>, 
    },
    {
      key: "1",
      label: <div 
      onClick={() => 
        removeEvent(data?.id ?? '')
      }
      >ลบ</div>, 
    },
  ];

  return (
  <Col sm={12} md={8} xl={8} span={24} style={{ padding:'5px'}}>
    <CardContainer>
      {/* {data?.last_address && (
        <FixedTag color="magenta">ที่อยู่จัดส่งล่าสุด</FixedTag>
      )} */}
      <ImageWrapper>
        <Radio value={data?.id || ''} onChange={handleRadioChange}/>
      </ImageWrapper>
      <Content>
        <TextWrapper> 
          <Typography.Text className="text-order-product-name">
            {/* {convertTransport(data?.transport_type)} */}
          </Typography.Text>
          <Typography.Text className="text-order-product-name">
            {/* { data?. && <Tag >ที่อยู่เริ่มต้น</Tag> }  */}
          </Typography.Text>
        </TextWrapper>
        <TextWrapper>
          <Typography.Text className="text-order-product-name">
            ชื่อ :
          </Typography.Text>
          <Typography.Text className="text-order-product-name">
            {data?.name} 
          </Typography.Text>
        </TextWrapper>

        <TextWrapper>
          <Typography.Text className="text-order-product-name">
            เบอร์โทรศัพท์ :
          </Typography.Text>
          <Typography.Text className="text-order-product-name">
            {data?.telephone} 
          </Typography.Text>
        </TextWrapper>

        <TextWrapper>
          <Typography.Text className="text-order-product-name">
            ที่อยู่ : {data?.address_text} 
          </Typography.Text>
        </TextWrapper>

        <TextWrapper>
          <Typography.Text className="text-order-product-name">
            หมายเลขประจำตัวผู้เสียภาษี : {data?.tax_no} 
          </Typography.Text>
        </TextWrapper>

      </Content>
      {canUpdate && (
        <MoreOptionsContainer>
        <Dropdown
          menu={{ items }}
          trigger={['click']}
          open={isDropdownOpen}
          onOpenChange={handleDropdownVisibleChange}
        >
          <MoreOptions>
            <MoreOutlined />
          </MoreOptions>
        </Dropdown>
      </MoreOptionsContainer>
      )}


    </CardContainer>
  </Col>
  );
};

export default TaxAddressCard;

const ImageWrapper = styled.div`
 `;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;  
`;

const CardContainer = styled.div`
  display: flex;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 16px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const MoreOptionsContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
`;


const MoreOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e0e0e0;
  }
`;

const FixedTag = styled(Tag)`
  position: absolute;
  top: 20px;
  right: 20px;
`;